import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div style={page}>
      <div style={topBar}>
        <span style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>Lot'N'Go</span>
      </div>
      <div style={body}>
        <div style={{ fontSize: '48px', fontWeight: 800, color: '#111', marginBottom: '8px', fontFamily: "'Manrope', system-ui, sans-serif" }}>404</div>
        <div style={{ fontSize: '18px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>
          {t('not_found')}
        </div>
        <div style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '24px' }}>
          {t('page_not_exist')}
        </div>
        <button onClick={() => navigate('/')} style={btn}>
          {t('go_back_home')}
        </button>
      </div>
    </div>
  );
}

const page: React.CSSProperties = {
  display:         'flex',
  flexDirection:   'column',
  minHeight:       '100dvh',
  maxWidth:        '430px',
  margin:          '0 auto',
  backgroundColor: '#f8f9fa',
  fontFamily:      "'Inter', system-ui, -apple-system, sans-serif",
};

const topBar: React.CSSProperties = {
  display:              'flex',
  alignItems:           'center',
  justifyContent:       'center',
  padding:              '0 16px',
  height:               '44px',
  backgroundColor:      'rgba(248,249,250,0.85)',
  backdropFilter:       'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
};

const body: React.CSSProperties = {
  flex:           1,
  display:        'flex',
  flexDirection:  'column',
  alignItems:     'center',
  justifyContent: 'center',
  padding:        '24px',
  textAlign:      'center',
};

const btn: React.CSSProperties = {
  display:      'block',
  width:        '100%',
  maxWidth:     '240px',
  height:       '44px',
  borderRadius: '8px',
  border:       'none',
  background:   'linear-gradient(135deg, #005bc0, #004fa9)',
  color:        '#f7f7ff',
  fontSize:     '14px',
  fontWeight:   600,
  cursor:       'pointer',
};
